<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form" v-model="valid">
                <v-container style="padding-top: 100px">
                    <v-layout row wrap>
                        <v-flex offset-xs2 xs10>
                            <a href="/dashboard">Личный кабинет</a>
                        </v-flex>
                        <v-flex offset-xs2 xs10 mb-5>
                            <h1>Вознаграждение</h1>
                        </v-flex>
                        <v-flex xs12 sm10>
                            <div class="tabs-container">
                                <v-tabs
                                    v-model="activeTab"
                                    slider-color="#000"
                                    show-arrows
                                    center-active
                                    class="scrollable-tabs"
                                >
                                    <v-tab
                                        v-for="item in tabItems"
                                        :key="item.code"
                                        :value="'tab-' + item.code"
                                        @click="change(item.code)"
                                    >
                                        {{ item.name }}
                                    </v-tab>
                                </v-tabs>
                            </div>
                        </v-flex>
                        <v-flex xs12 v-if="commissionTemplates.length > 0">
                            <h4 class="py-2 py-sm-4">Созданные шаблоны</h4>
                            <div class="templates-wrapper">
                                <v-tabs
                                    slider-color="#000"
                                    hide-slider
                                    mandatory
                                    show-arrows
                                    class="template-tabs"
                                >
                                    <v-tab
                                        v-for="item in commissionTemplates"
                                        :key="item.id"
                                        :href="'/commission-template/' + item.id + '?type=' + type"
                                        class="template-tab"
                                    >
                                        {{ item.name_template || item.name }}
                                    </v-tab>
                                </v-tabs>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm10 v-if="showSearchField || activeTab === 'tab-transit'">
                            <v-btn :href="commissionTemplateNewUrl"
                                v-if="this.isAdmin === true"
                                class="submit-button block mb-3 mt-2">
                                Создать новый шаблон
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm10 v-if="showSearchField">
                            <v-text-field
                                class="region-search"
                                v-model="regionSearch"
                                :label="colName"
                                :placeholder="filterPlaceholder"
                                clearable
                                style="margin-top:0; padding-top: 0;"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container pb-0>
                    <div class="table-scroll-wrapper">

                        <div class="table-header">
                            <div class="header-content">
                                <span class="title">{{ typeName }}</span>
                                <v-btn v-if="isAdmin" @click="validateAndSave"
                                       class="submit-button submit-button-commissions">
                                    Сохранить
                                </v-btn>
                            </div>
                        </div>

                        <b2b-commissions-table
                            v-if="showCommissionsTable"
                            :canEdit="isAdmin"
                            :regions="regions"
                            :companies="companies"
                            :commissions="commissions"
                            :commissionRules="commissionRules"
                            :regionSearch="regionSearch"
                        />

                        <b2b-commissions-crosses
                            v-if="activeTab === 'tab-crosses'"
                            :canEdit="isAdmin"
                            :regions="regions"
                            :companies="companies"
                            :commissions="commissions"
                            :commissionRules="commissionRules"
                            :regionSearch="regionSearch"
                        />

                        <b2b-commissions-antimite
                            v-if="activeTab === 'tab-antimite'"
                            :canEdit="isAdmin"
                            :regions="regions"
                            :companies="companies"
                            :commissions="commissions"
                            :commissionRules="commissionRules"
                            :regionSearch="regionSearch"
                        />

                        <b2b-commissions-banking-products
                            v-if="activeTab === 'tab-banking-products'"
                            :canEdit="isAdmin"
                            :commissions="commissions"
                        />

                        <b2b-commissions-transit
                            v-if="activeTab === 'tab-transit'"
                            :canEdit="isAdmin"
                            :regions="regions"
                            :companies="companies"
                            :commissions="commissions"
                            :templates="commissionTemplates"
                            @update:commissions="commissions = $event"
                            :commissionRules="commissionRules"
                            :regionSearch="regionSearch"
                        />
                    </div>
                </v-container>


            </v-form>
        </v-content>
    </v-app>
</template>

<script>
export default {
    props: ['type', 'comps', 'regs', 'comms', 'admin', 'role', 'commrules', 'commTemplates'],

    data: () => ({
        valid: true,
        isAdmin: false,
        userRole: '',
        companies: [],
        regions: [],
        commissions: {},
        commissionRules: {},
        commissionTemplates: [],
        mortgageCommissionTemplates: [],
        transitCommissionTemplates: [],

        commissionTemplateNewUrl: "/commission-template/new?type=",
        typeName: 'ОСАГО',
        colName: 'Регион',
        filterPlaceholder: 'Начните вводить регион',
        tabItems: [],
        activeTab: null,

        showMainCommHeader: true,
        showCommHeader: false,
        regionSearch: '',

        scrollListener: null,
        resizeListener: null,
    }),

    computed: {
        showSearchField() {
            return !['tab-crosses', 'tab-antimite', 'tab-banking-products', 'tab-transit'].includes(this.activeTab);
        },
        showCompanyLogos() {
            return this.showSearchField;
        },
        showCommissionsTable() {
            return this.showSearchField;
        }
    },

    created() {
        this.isAdmin = Boolean(this.admin);
        this.userRole = this.role;
        this.regions = typeof this.regs === 'string'
            ? JSON.parse(this.regs)
            : (Array.isArray(this.regs) ? this.regs : (this.regs || []));
        this.companies = typeof this.comps === 'string'
            ? JSON.parse(this.comps)
            : (Array.isArray(this.comps) ? this.comps : (this.comps || []));
        this.commissions = typeof this.comms === 'string'
            ? JSON.parse(this.comms)
            : (this.comms && typeof this.comms === 'object' ? JSON.parse(JSON.stringify(this.comms)) : {});
        this.commissionRules = typeof this.commrules === 'string'
            ? JSON.parse(this.commrules || '{}')
            : (this.commrules && typeof this.commrules === 'object' ? this.commrules : {});
        this.commissionTemplates = typeof this.commTemplates === 'string'
            ? JSON.parse(this.commTemplates || '[]')
            : (Array.isArray(this.commTemplates) ? this.commTemplates : (this.commTemplates || []));
        this.commissionTemplateNewUrl = "/commission-template/new?type=" + this.type;

        for (let cmp in this.companies) {
            if (!this.companies.hasOwnProperty(cmp)) continue;
            let company = this.companies[cmp];
            if (this.commissions[company.alias] === undefined) {
                this.commissions[company.alias] = {}
            }
            if (this.commissionRules[company.alias] === undefined) {
                this.commissionRules[company.alias] = {}
            }
            if (!this.regions.length && company.crosses) {
                for (let cross of company.crosses) {
                    if (this.commissions[company.alias][cross.id] === undefined) {
                        this.commissions[company.alias][cross.id] = 0;
                    }
                }
            }
            for (let rgn in this.regions) {
                if (!this.regions.hasOwnProperty(rgn)) continue;
                let region = this.regions[rgn];
                if (this.commissions[company.alias][region.id] === undefined) {
                    this.commissions[company.alias][region.id] = 0;
                }
                if (this.commissionRules[company.alias][region.id] === undefined) {
                    this.commissionRules[company.alias][region.id] = 0;
                }
            }
        }

        const types = {
            mortgage: 'Страхование ипотеки',
            osago: 'ОСАГО',
            crosses: 'Кросс-продукты',
            antimite: 'Антиклещ',
            banking_products: 'Банковские продукты',
            transit: 'ОСАГО не РФ'
        };
        this.typeName = types[this.type] || '';

        this.colName = (this.type === 'osago') ? 'Регион' : 'Банк';
        this.filterPlaceholder = (this.type === 'osago') ? 'Начните вводить регион' : 'Начните вводить банк';
        this.tabItems = [
            {id: 0, code: 'osago', name: 'ОСАГО'},
            {id: 1, code: 'mortgage', name: 'Страхование ипотеки'},
            {id: 2, code: 'crosses', name: 'Кросс-продукты'},
            {id: 3, code: 'antimite', name: 'Антиклещ'},
            {id: 4, code: 'banking-products', name: 'Банковские продукты'},
            {id: 5, code: 'transit', name: 'ОСАГО не РФ'}
        ];
        this.activeTab = 'tab-' + this.type;
    },

    methods: {
        validateAndSave() {
            if (this.$refs.form.validate()) {
                this.save();
            } else {
                this.$nextTick(() => {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
            }
        },

        goToFirstError() {
            this.$vuetify.goTo('.error--text', {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        },

        save() {
            let postData = this.commissions;

            if (this.type === 'banking-products') {
                postData = Object.values(this.commissions).reduce((acc, product) => {
                    if (product.id && product.commission_percentage !== undefined) {
                        acc[product.id] = product.commission_percentage;
                    }
                    return acc;
                }, {});
            } else if (this.type === 'transit') {
                // Сохраняем данные по индексам (без русских названий стран)
                // Формат: { alias: [value0, value1, value2, ...] }
                const converted = {};
                Object.keys(this.commissions).forEach(alias => {
                    converted[alias] = [];
                    const companyComm = this.commissions[alias] || {};
                    
                    // Сортируем ключи по числовому значению и создаем массив
                    const sortedKeys = Object.keys(companyComm).sort((a, b) => {
                        const aNum = parseInt(a);
                        const bNum = parseInt(b);
                        return isNaN(aNum) || isNaN(bNum) ? 0 : aNum - bNum;
                    });
                    
                    // Заполняем массив значениями по индексам
                    sortedKeys.forEach(regionId => {
                        const index = parseInt(regionId);
                        if (!isNaN(index)) {
                            // Увеличиваем массив до нужного размера, если нужно
                            while (converted[alias].length <= index) {
                                converted[alias].push('');
                            }
                            converted[alias][index] = companyComm[regionId] || '';
                        }
                    });
                });

                // Для обычного сохранения (не шаблона) не отправляем name_template
                // Это позволит сохранить данные в дефолтный шаблон, который не будет отображаться в списке
                postData = {
                    data: converted
                    // name_template не указываем - это означает сохранение комиссий, а не создание шаблона
                };
            }

            axios.post(window.location.href, JSON.stringify(postData)).then(response => {
                PNotify.success('Изменения успешно сохранены.');
            }).catch(error => {
                if (error.response.data.message) {
                    PNotify.alert(error.response.data.message);
                }
            });
        },
        change(tab) {
            window.location.href = "/commissions?type=" + tab
        },
        getUrl(path) {
            return window.location.origin + '/' + path;
        },

    }
}
</script>

<style scoped>

/deep/ .v-icon.v-icon.v-icon--link {
    display: flex;
    justify-content: center;
}

.table-scroll-wrapper {
    overflow-x: auto;
    position: relative;
}

.table-header {
    position: sticky;
    top: 0;
    z-index: 25;
    background: white;
    padding: 10px 0;
}

.header-content {
    display: flex;
    align-items: center;
    padding: 0 16px;
}

.title {
    font-size: 20px;
    font-weight: 700;
}

.table-scroll-wrapper {
    overflow-x: auto;
    position: relative;
}


/* Фиксируем первый столбец */
.region-field {
    position: sticky;
    left: 0;
    z-index: 10;
    background: white;
}

/* Фиксированный заголовок */
.sticky-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    overflow-x: hidden;
    background: white;
    border-bottom: solid 2px black;
    padding: 10px;
}

/* Мобильная адаптация */
@media (max-width: 960px) {
    .tabs-container {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        margin-bottom: 12px;
    }

    .scrollable-tabs {
        min-width: 600px; /* Ширина больше экрана для прокрутки */
    }

    .templates-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .template-tabs {
        min-width: 100%;
        display: inline-flex;
    }

    .template-tab {
        flex-shrink: 0;
        font-size: 13px;
        padding: 0 12px;
    }

    .region-search {
        max-width: 100% !important;
    }
}

/* Для экранов больше 960px */
@media (min-width: 961px) {
    .scrollable-tabs {
        overflow: visible !important;
    }
}


.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;
    height: 56px;
    background-color: #00ba57 !important;
    border-radius: 100px;
}

.submit-button-commissions {
    height: 40px;
    font-size: 16px !important;
}

/deep/ h1 {
    font-size: 2.5rem;
    line-height: 1.1;
    font-weight: 700;
}

/deep/ .v-tabs {
    overflow-x: auto;
}

.small-field {
    height: 100px;
    min-width: 110px;
    padding: 0 10px;
    flex: 1 0 auto;
}

.region-field {
    width: 240px;
    padding-left: 0 !important;
    flex-shrink: 0;
}

#commheader {
    border-bottom: solid 2px black;
    background-color: #fff;
    z-index: 3;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    padding: 10px;
    overflow-x: auto;
}

#maincommheader {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
}

.region-search {
    max-width: 240px;
    width: 100%;
}

/* Адаптивные стили */
@media (max-width: 960px) {
    /deep/ h1 {
        font-size: 2rem;
    }

    .region-field {
        width: 200px;
    }

    .small-field {
        min-width: 90px;
    }
}

@media (max-width: 600px) {
    /deep/ h1 {
        font-size: 1.75rem;
    }

    .region-field {
        width: 180px;
    }

    .small-field {
        min-width: 80px;
        padding: 0 5px;
    }

    #commheader, #maincommheader {
        padding: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/Commissions.vue